import {
  getReq,
  postReq,
  deleteSendReq,
  putReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  END_POINTS
} from '@/api'
import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  projAcctCurEntityList: [],
  projAcctCurEntityInfo: {
    entityId: '',
    projId: '',
    entityName: '',
    entityDesc: '',
    ctrAcctId: '',
    tgtCtrAcctId: '',
    colId: '',
    entityContact: '',
    content: '',
    compId: '',
    colType: '',
    seq: 0,
    contractNo: '',
    status: '',
    entityStatus: '',
    lockBy: '',
    lockOn: new Date(0),
    crtBy: '',
    crtOn: new Date(0),
    updBy: '',
    updOn: new Date(0),
    //
    indUsed: ''
  },
  editIndex: -1,
  editAction: '',
  END_STATE: null
}

const getters = {

}

const actions = {
  async insertProjAcctCurEntity({
    dispatch,
    commit,
    state
  }, {projId, compId, codeParam}) {
    // debugger
    const insertObj = await postReq(END_POINTS.INSERT_RSP_PROJ_ACCT_CUR_ENTITY, {
      data: {
        entityName: state.projAcctCurEntityInfo.entityName,
        ctrAcctId: state.projAcctCurEntityInfo.ctrAcctId,
        tgtCtrAcctId: state.projAcctCurEntityInfo.tgtCtrAcctId,
        entityContact: state.projAcctCurEntityInfo.entityContact,
        content: state.projAcctCurEntityInfo.content,
        contractNo: state.projAcctCurEntityInfo.contractNo,
        // status: state.projAcctCurEntityInfo.status,
        //
        projId: projId,
        compId: compId
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return insertObj
  },
  async updateProjAcctCurEntityKeyInfo({
    dispatch,
    commit,
    state
  }, {entityId, projId, compId, codeParam}) {
    // debugger
    let projAcctCurEntityInfo = {
      entityName: state.projAcctCurEntityInfo.entityName,
      ctrAcctId: state.projAcctCurEntityInfo.ctrAcctId,
      tgtCtrAcctId: state.projAcctCurEntityInfo.tgtCtrAcctId,
      // entityContact: state.projAcctCurEntityInfo.entityContact,
      // content: state.projAcctCurEntityInfo.content,
      // contractNo: state.projAcctCurEntityInfo.contractNo,
      // status: state.projAcctCurEntityInfo.status,
      //
      key: {
        entityId: entityId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJ_ACCT_CUR_ENTITY_KEY_INFO, {
      data: projAcctCurEntityInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async updateProjAcctCurEntity({
    dispatch,
    commit,
    state
  }, {entityId, projId, compId, codeParam}) {
    let projAcctCurEntityInfo = {
      entityName: state.projAcctCurEntityInfo.entityName,
      ctrAcctId: state.projAcctCurEntityInfo.ctrAcctId,
      tgtCtrAcctId: state.projAcctCurEntityInfo.tgtCtrAcctId,
      entityContact: state.projAcctCurEntityInfo.entityContact,
      content: state.projAcctCurEntityInfo.content,
      contractNo: state.projAcctCurEntityInfo.contractNo,
      // status: state.projAcctCurEntityInfo.status,
      //
      key: {
        entityId: entityId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJ_ACCT_CUR_ENTITY, {
      data: projAcctCurEntityInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async removeProjAcctCurEntity({
    commit,
    state
  }, {entityId, projId, compId, codeParam}) {
    const deleteObject = await deleteSendReq(END_POINTS.REMOVE_RSP_PROJ_ACCT_CUR_ENTITY + `?entityId=${entityId}&projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return deleteObject
  },
  async findProjAcctCurEntity({
    commit
  }, {entityId, projId, compId, codeParam}) {
    const responseData = await getReq(END_POINTS.FIND_RSP_PROJ_ACCT_CUR_ENTITY + `?entityId=${entityId}&projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    if (responseData.code === 2000) {
      commit('updateProjAcctCurEntityInfo', responseData.data)
    }
  },
  async findProjAcctCurEntityList({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    const response = await getReq(END_POINTS.FIND_RSP_PROJ_ACCT_CUR_ENTITY_LIST + `?projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateProjAcctCurEntityList', response)
  },
  async findProjAcctCurEntityStatisticList({
    commit,
    state,
    rootState
  }, { projId, compId, searchedForm, codeParam }) {
    // let searchedForm = state.searchedForm || state.emptySearchInfo
    let data = {
      projId,
      compId,
      // entityName: searchedForm.searchEntityName,
      searchType: searchedForm.searchType,
      searchMonth: new Date(Utils.getMonthFirstDay(searchedForm.searchMonth)).getTime(),
      searchMonthType: searchedForm.searchMonthType,
      startDt: new Date(searchedForm.searchStartDt).getTime(),
      endDt: new Date(searchedForm.searchEndDt).getTime()
    }
    const response = await postReq(END_POINTS.FIND_RSP_PROJ_ACCT_CUR_ENTITY_STATISTIC_LIST, {
      data,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateProjAcctCurEntityList', response)
  },
  END_ACTIONS() {}
}

const mutations = {
  updateProjId(state, value) {
    state.projAcctCurEntityInfo.projId = value
  },
  updateEntityId(state, value) {
    state.projAcctCurEntityInfo.entityId = value
  },
  updateEntityName(state, value) {
    state.projAcctCurEntityInfo.entityName = value
  },
  updateEntityDesc(state, value) {
    state.projAcctCurEntityInfo.entityDesc = value
  },
  updateCtrAcctId(state, value) {
    state.projAcctCurEntityInfo.ctrAcctId = value
  },
  updateTgtCtrAcctId(state, value) {
    state.projAcctCurEntityInfo.tgtCtrAcctId = value
  },
  updateColId(state, value) {
    state.projAcctCurEntityInfo.colId = value
  },
  updateEntityContact(state, value) {
    state.projAcctCurEntityInfo.entityContact = value
  },
  updateContent(state, value) {
    state.projAcctCurEntityInfo.content = value
  },
  updateCompId(state, value) {
    state.projAcctCurEntityInfo.compId = value
  },
  updateColType(state, value) {
    state.projAcctCurEntityInfo.colType = value
  },
  updateSeq(state, value) {
    state.projAcctCurEntityInfo.seq = value
  },
  updateContractNo(state, value) {
    state.projAcctCurEntityInfo.contractNo = value
  },
  updateStatus(state, value) {
    state.projAcctCurEntityInfo.status = value
  },
  updateEntityStatus(state, value) {
    state.projAcctCurEntityInfo.entityStatus = value
  },
  updateLockBy(state, value) {
    state.projAcctCurEntityInfo.lockBy = value
  },
  updateLockOn(state, value) {
    state.projAcctCurEntityInfo.lockOn = value
  },
  updateCrtBy(state, value) {
    state.projAcctCurEntityInfo.crtBy = value
  },
  updateCrtOn(state, value) {
    state.projAcctCurEntityInfo.crtOn = value
  },
  updateUpdBy(state, value) {
    state.projAcctCurEntityInfo.updBy = value
  },
  updateUpdOn(state, value) {
    state.projAcctCurEntityInfo.updOn = value
  },
  updateProjAcctCurEntityList(state, response) {
    if (response.success === true && response.data.length) {
      state.projAcctCurEntityList = response.data
    } else {
      state.projAcctCurEntityList = []
    }
  },
  updateProjAcctCurEntityListEmpty(state) {
    state.editIndex = -1
    state.projAcctCurEntityList = []
  },
  updateProjAcctCurEntityEmpty(state) {
    state.projAcctCurEntityInfo.projId = ''
    state.projAcctCurEntityInfo.entityId = ''
    state.projAcctCurEntityInfo.entityName = ''
    state.projAcctCurEntityInfo.entityDesc = ''
    state.projAcctCurEntityInfo.ctrAcctId = ''
    state.projAcctCurEntityInfo.tgtCtrAcctId = ''
    state.projAcctCurEntityInfo.colId = ''
    state.projAcctCurEntityInfo.entityContact = ''
    state.projAcctCurEntityInfo.content = ''
    state.projAcctCurEntityInfo.compId = ''
    state.projAcctCurEntityInfo.colType = ''
    state.projAcctCurEntityInfo.seq = 0
    state.projAcctCurEntityInfo.contractNo = ''
    state.projAcctCurEntityInfo.status = ''
    state.projAcctCurEntityInfo.entityStatus = ''
    state.projAcctCurEntityInfo.lockBy = ''
    state.projAcctCurEntityInfo.lockOn = new Date(0)
    state.projAcctCurEntityInfo.crtBy = ''
    state.projAcctCurEntityInfo.crtOn = new Date(0)
    state.projAcctCurEntityInfo.updBy = ''
    state.projAcctCurEntityInfo.updOn = new Date(0)

    state.projAcctCurEntityInfo.indUsed = ''
  },
  updateProjAcctCurEntityInfo(state, projAcctCurEntityInfo) {
    // debugger
    state.projAcctCurEntityInfo.projId = projAcctCurEntityInfo.projId
    state.projAcctCurEntityInfo.entityId = projAcctCurEntityInfo.entityId
    state.projAcctCurEntityInfo.entityName = projAcctCurEntityInfo.entityName
    state.projAcctCurEntityInfo.entityDesc = projAcctCurEntityInfo.entityDesc
    state.projAcctCurEntityInfo.ctrAcctId = projAcctCurEntityInfo.ctrAcctId
    state.projAcctCurEntityInfo.tgtCtrAcctId = projAcctCurEntityInfo.tgtCtrAcctId
    state.projAcctCurEntityInfo.colId = projAcctCurEntityInfo.colId
    state.projAcctCurEntityInfo.entityContact = projAcctCurEntityInfo.entityContact
    state.projAcctCurEntityInfo.content = projAcctCurEntityInfo.content
    state.projAcctCurEntityInfo.compId = projAcctCurEntityInfo.compId
    state.projAcctCurEntityInfo.colType = projAcctCurEntityInfo.colType
    state.projAcctCurEntityInfo.seq = projAcctCurEntityInfo.seq
    state.projAcctCurEntityInfo.contractNo = projAcctCurEntityInfo.contractNo
    state.projAcctCurEntityInfo.status = projAcctCurEntityInfo.status
    state.projAcctCurEntityInfo.entityStatus = projAcctCurEntityInfo.entityStatus
    state.projAcctCurEntityInfo.lockBy = projAcctCurEntityInfo.lockBy
    state.projAcctCurEntityInfo.lockOn = projAcctCurEntityInfo.lockOn
    state.projAcctCurEntityInfo.crtBy = projAcctCurEntityInfo.crtBy
    state.projAcctCurEntityInfo.crtOn = projAcctCurEntityInfo.crtOn
    state.projAcctCurEntityInfo.updBy = projAcctCurEntityInfo.updBy
    state.projAcctCurEntityInfo.updOn = projAcctCurEntityInfo.updOn
    //
    state.projAcctCurEntityInfo.indUsed = projAcctCurEntityInfo.indUsed
  },
  updateEditIndex(state, value) {
    state.editIndex = value
  },
  updateEditAction(state, value) {
    state.editAction = value
  },
  // newEmptyRowObj() {
  //   return {
  //     ctrAcctId: '',
  //     type: '',
  //     indUsed: '',
  //     status: ''
  //   }
  // },
  appendBottomRow() {
    this.commit('confProjAcctCurEntityManage/updateProjAcctCurEntityEmpty')
    let obj = {...state.projAcctCurEntityInfo}
    // debugger
    obj.isBottomRow = true
    state.projAcctCurEntityList.push(obj)
  },
  handleAdd(state, {row, index, ctrAcctId, tgtCtrAcctId}) {
    // debugger
    this.commit('confProjAcctCurEntityManage/updateProjAcctCurEntityEmpty')
    this.commit('confProjAcctCurEntityManage/updateEditIndex', index)
    this.commit('confProjAcctCurEntityManage/updateEditAction', 'insert')
    //
    this.commit('confProjAcctCurEntityManage/updateCtrAcctId', ctrAcctId)
    this.commit('confProjAcctCurEntityManage/updateTgtCtrAcctId', tgtCtrAcctId)
  },
  handleEdit(state, {row, index}) {
    // debugger
    this.commit('confProjAcctCurEntityManage/updateProjAcctCurEntityInfo', row)
    this.commit('confProjAcctCurEntityManage/updateEditIndex', index)
    this.commit('confProjAcctCurEntityManage/updateEditAction', 'update')
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/confProjAcctCurEntityManage.js